import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { SubjectLineMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";
import { displayStringForMatchCondition } from "../rule-utils";

export type SubjectLineState = Required<Omit<Condition.SubjectLine, "type">>;

export const SUBJECT_LINE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SubjectLineState>>,
): ConditionType<SubjectLineState, Condition.SubjectLine> => ({
  name: CONDITION_NAMES[Condition.SUBJECT_LINE],
  description(state) {
    return displayStringForMatchCondition(
      "Subject line",
      state.matchMode,
      state.queryStrings,
    );
  },
  Details(props: ConditionTypeDetailsProps<SubjectLineState>) {
    return React.createElement(Details, props);
  },
  empty: {
    fuzzy_match: "",
    queryStrings: [],
    caseSensitive: false,
    matchMode: SubjectLineMatchType.CONTAINS,
  },
  fromModel(model) {
    return {
      ...model,
      queryStrings: model.queryStrings || [model.fuzzy_match || ""],
      caseSensitive: model.caseSensitive ?? false,
      matchMode: model.matchMode ?? SubjectLineMatchType.CONTAINS,
    };
  },
  toModel(state) {
    return { type: Condition.SUBJECT_LINE, ...state };
  },
  valid() {
    return true;
  },
});
